var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FFDD00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1343_51081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#FFDD00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1343_51081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47949 15.5373L15.5378 10.9998L8.47949 6.46234V15.5373ZM11.0003 21.0832C9.60546 21.0832 8.29463 20.8185 7.06783 20.2891C5.84102 19.7597 4.77387 19.0413 3.86637 18.1338C2.95887 17.2263 2.24043 16.1591 1.71105 14.9323C1.18168 13.7055 0.916992 12.3947 0.916992 10.9998C0.916992 9.60498 1.18168 8.29414 1.71105 7.06734C2.24043 5.84053 2.95887 4.77338 3.86637 3.86588C4.77387 2.95838 5.84102 2.23994 7.06783 1.71057C8.29463 1.18119 9.60546 0.916504 11.0003 0.916504C12.3952 0.916504 13.706 1.18119 14.9328 1.71057C16.1596 2.23994 17.2268 2.95838 18.1343 3.86588C19.0418 4.77338 19.7602 5.84053 20.2896 7.06734C20.819 8.29414 21.0837 9.60498 21.0837 10.9998C21.0837 12.3947 20.819 13.7055 20.2896 14.9323C19.7602 16.1591 19.0418 17.2263 18.1343 18.1338C17.2268 19.0413 16.1596 19.7597 14.9328 20.2891C13.706 20.8185 12.3952 21.0832 11.0003 21.0832Z",
    fill: "#494949"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.8230e7f21c03cda19a0c41a550506810.svg";
export { ForwardRef as ReactComponent };